import { useBreakpointValue } from '@bonusly/design-system';
import { useSpoofing } from '@bonusly/who-am-i';

// NOTE: 57px is the height of the mobile navbar (56px) + 1px border
const MOBILE_NAVBAR_HEIGHT = 57; // 56px navbar + 1px border
const SPOOFING_BANNER_HEIGHT = 60;

/**
 * Hook to calculate the top offset needed for fixed-position elements,
 * accounting for the mobile navbar and spoofing banner.
 *
 * @returns The pixel offset from the top of the viewport
 */
export const useTopNavOffset = (): number => {
	const { isSpoofing, isDemoing } = useSpoofing();
	const isSpoofingBannerVisible = isSpoofing && !isDemoing;

	// On mobile (base), we have a navbar that takes up space
	// On larger screens (sm+), the navbar is not fixed at the top
	const mobileOffset = MOBILE_NAVBAR_HEIGHT + (isSpoofingBannerVisible ? SPOOFING_BANNER_HEIGHT : 0);
	const desktopOffset = isSpoofingBannerVisible ? SPOOFING_BANNER_HEIGHT : 0;

	return useBreakpointValue({ base: mobileOffset, sm: desktopOffset }) ?? mobileOffset;
};
